import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { appReducers } from './store/reducers/app.reducers';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AuthService } from './services/auth.service';
import { TariffService } from './services/tariff.service';
import { AgentService } from './services/agent.service';
import { AgentGroupService } from './services/agentgroup.service';
import { ProviderService } from './services/provider.service';
import { ServiceService } from './services/service.service';
import { AccountService } from './services/account.service';
import { ServiceTypeService } from './services/servicetype.service';
import { ServiceGroupService } from './services/servicegroup.service';
import { StatusService } from './services/status.service';
import { EnableToSendService } from './services/enabletosend.service';
import { AccountTypeService } from './services/accounttype.service';
import { PinCardService } from './services/pincard.service';
import { PartnerService } from './services/partner.service';
import { GroupProviderService } from './services/groupprovider.service';
import { ImportMasterStatusService } from './services/importmasterstatus.service';
import { ImportDetailStatusService } from './services/importdetailstatus.service';
import { AppHttpInterceptor } from './services/http.interceptor';
import { PinCodeStatusService } from './services/pincodestatus.service';
import { TransactionStatus } from './services/transactionstatus.service';
import { TransactionType } from './services/transactiontype.service';
import { Transaction } from './services/models/transaction/transaction.model';
import { TransationService } from './services/transaction.service';
import { TransactionBatchStatus } from './services/transactionbatchstatus.service';
import { ErrorMessageComponent } from './components/errormessage/errormessage.component';
import { RoleService } from './services/role.service';
import { PostiveIntegerInputDirective } from './directives/positive-integer-input.directive';

import { SimService } from './services/sim.service';
import { SimTypeService } from './services/simtype.service';
import { PaymentService } from './services/payment.service';
import { PaymentType } from './services/paymenttype.service';
import { PaymentStatus } from './services/paymentstatus.service';


@NgModule({
  imports: [
    BrowserAnimationsModule,
    NgxPaginationModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      closeButton: true,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    StoreModule.forRoot(appReducers)
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    ErrorMessageComponent
    
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    },
    AuthService,
    AccountService,
    AgentService,
    ServiceService,
    ProviderService,
    AgentGroupService,
    ServiceTypeService,
    StatusService,
    PartnerService,
    EnableToSendService,
    AccountTypeService,
    ServiceGroupService,
    PinCardService,
    PinCodeStatusService,
    GroupProviderService,
    ImportMasterStatusService,
    ImportDetailStatusService,
    TransactionStatus,
    TransactionType,
    TransactionBatchStatus,
    Transaction,
    TariffService,
    TransationService,
    RoleService,
    
    SimService, 
    SimTypeService, 
    PaymentService,
    PaymentType,
    PaymentStatus,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
